export default {
	computed: {
		baseURL() {
			return `https://${window.location.hostname}`;
		},
		shareModalTitle() {
			return this.$I18n ? this.$I18n.trans('commons.type_share', { type: this.transChoiceUcFirst('commons.video', 1) }) : 'Share video';
		},
		shareUrlLabel() {
			return this.$I18n ? this.$Helpers.ucfirst(this.transChoiceUcFirst('commons.video', 1)) + '-' + this.$I18n.trans('commons.url') : 'Video-URL';
		},
	},
	data() {
		return {
			isShareModalOpen: false,
			shareItem:        null,
			shareLinks:       null,
			shareUrl:         null,
		};
	},
	methods: {
		handleShare(item) {
			this.openShareModal(item);
		},
		openShareModal(item) {
			this.shareItem = item;
			this.shareUrl = this.shareItem.url;
			this.shareLinks = this.shareItem.shareLinks;
			this.isShareModalOpen = true;
		},
		closeShareModal() {
			this.isShareModalOpen = false;
		},
	},
};
